import React from 'react';
import styles from './LastStep.module.scss';

const LastStep = ({ text, lastNumber }) => {
  return (
    <div className={ styles.LastStep }>
      { lastNumber }. { text }
    </div>
  );
};

export default LastStep;
